// tslint:disable
export const agreementConfig = {

        template_qzhyqq: `<div style='overflow-x: hidden;'>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">{{productName}}</span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">【特别提示】</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">一、定义</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span><span
        style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span><span
        style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span><span
style="font-family:宋体; font-size:10.5pt">{{productName}}</span><span
style="font-family:宋体; font-size:10.5pt">的应用。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.4 红包：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数等。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获红包按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得红包、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">二、本应用服务</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.1 【获取】您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.2 【功能】您在可在本应用内进行相应互动点击操作，满足一定条件时可获得红包奖励，并按规则进行红包兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的红包，应用内所展示红包数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.3 【更新】为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括红包兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.4 【广告】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，请您自行辨认本应用内广告的真实性。</span><span
style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免上当受骗。</span><span
</p>       


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.5 【中止、变更、中断】我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span><span
style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
</p>     

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">三、用户</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.1 【注册条件】您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.2 【使用目的】您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行红包兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.3【用户账号】我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.4【转让和共享禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内红包仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.5 【第三方工具禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取红包、频繁申请红包兑换或体现等可能影响本应用正常运行的行为。</span><span
style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.6 【账号注销】用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.7 【故障谅解】您理解互联网服务可能因技术或网络故障等原因导致红包兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.8【设备和网络】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span><span
style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.9 【限制传播】我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.10 【个人信息】保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">四、红包和兑换</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.1 【红包获取】我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的红包。但</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">成功获取红包数值不等同于最终可实际兑换价值，您必须要满足我们为您设置的兑换条件方可成功进行兑换，未成功兑换的红包不具有任何经济价值。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.2 【红包展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解红包所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。</span></p>           

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.3 【兑换资格】您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取红包等违规行为；已获取且在有效期内的红包数值大于等于您欲兑换数值。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.4 【数值展示】应用内红包处所显示数值并非实际可兑换数值，该数值系通过已获得红包数值减去已兑换和消耗红包数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.5 【兑换申请】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，</span><span
style="font-family:宋体; font-size:10.5pt">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换。</span>
</p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.6 【兑换审核】我们会在收到您的兑换申请后尽快为您处理，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换红包数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.7 【兑换发放】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意红包可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span><span
style="font-family:宋体; font-size:10.5pt">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
</p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.8 【兑换放弃】您理解并同意如您连续20日未登录本应用账号或自行注销本应用账号，则视为您已自愿放弃账号内全部已获得红包的兑换，并不再向我们提出兑换申请。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">五、具体兑换规则</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.1 【兑换规则】您确认知悉和理解本应用内的红包获取和兑换应当在符合前述“红包和兑换”条件的基础上，再按照以下具体兑换规则对照进行兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如本部分“兑换规则”所述兑换条件高于前述“红包和兑换”中所列条件的，则以下述“兑换规则”部分为准；如低于前述“红包和兑换”中所列条件的，则以前述“红包和兑换”部分为准。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.2 【规则展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并知悉应用内页面显示兑换规则相关内容系本协议的组成部分，但受移动设备和应用界面等因素影响，兑换页面所载“提现规则”或其他名称标注的兑换规则内容可能并不完整，我们有权根据情况决定规则的展示形式，您应仔细阅读本协议中包括但不限于本部分关于红包兑换的内容。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.3 【兑换比例】您理解并知悉红包与实际兑换价值的比例以应用内页面所载比例为准，计算方式为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">可兑换红包数值乘以页面所载兑换比例。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.4 【提现规则】</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.【我的现金】提现规则</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">A、0.3元提现：如您想在{{productName}}【红包提现】账户成功提现0.3元，则不需要条件。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">B、500元提现：如您想在{{productName}}【红包提现】账户成功提现500元，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于500元；2）合成2048个数20个以上；3）登连续登录10天；4）等级达到25级；5）观看视频数达到300。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">C、800元提现：如您想在{{productName}}【红包提现】账户成功提现800元，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于800元；2）登连续登录12天；3）等级达到30级；4）观看视频数达到400。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">D、1500元提现：如您想在{{productName}}【红包提现】账户成功提现1500元，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于1500元；2）合成2048个数40个以上；3）登连续登录15天；4）等级达到32级；5）观看视频数达到600。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">E、3000元提现：如您想在{{productName}}【红包提现】账户成功提现3000元，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于3000元；2）合成2048个数50个以上；3）登连续登录20天；4）等级达到34级；5）观看视频数达到800。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.【2048兑换】提现规则</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">A、0.3元提现：如您想在{{productName}}【红包提现】账户成功提现0.3元，则合成2048个数2个可兑换</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">B、0.5元提现：如您想在{{productName}}【红包提现】账户成功提现0.5元，则合成2048个数5个可兑换。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">C、30元提现：如您想在{{productName}}【红包提现】账户成功提现30元，则需要同时满足以下几个条件即可成功提现：1）合成2048个数15个；2）登连续登录5天；3）等级达到25级；4）观看视频数达到300。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">D、80元提现：如您想在{{productName}}【红包提现】账户成功提现80元，则需要同时满足以下几个条件即可成功提现：1）合成2048个数30个；2）登连续登录7天；3）等级达到30级；4）观看视频数达到400。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">E、200元提现：如您想在{{productName}}【红包提现】账户成功提现200元，则需要同时满足以下几个条件即可成功提现：：1）合成2048个数50个；2）登连续登录10天；3）等级达到32级；4）观看视频数达到500。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">F、500元提现：如您想在{{productName}}【红包提现】账户成功提现500元，则需要同时满足以下几个条件即可成功提现：：1）合成2048个数100个；2）登连续登录15天；3）等级达到34级；4）观看视频数达到800。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">部分提现需要验证账号无风险，若有风险则须邀请好友验证辅助提现</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">六、违约处理</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.1 【商业目的和不正当手段】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部红包、收回已兑换奖励。</span><span
style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
</p>   

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.2 【不得侵害本应用权利】任何人未经我们同意不得从事以下行为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span><span
style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">七、不可抗力和免责事由</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.1 【不可抗力】您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.2【技术故障免责】在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.3【外来风险免责】您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span><span
style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
</p>  

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.4【违规处理免责】我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.5【第三方消费免责】本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.6 【涉财产行为免责】在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.7 【非可控故障免责】我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">八、其他条款</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.1 【协议生效和争议解决】本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.2 【知识产权声明】在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.3 【协议修订】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择注销已注册的本应用账号。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.4 【协议性质】您确认本协议系您作为用户与我司平等订立的用户协议，红包及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.5 【协议范围】您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站上发布的公告、规则等内容为本协议不可分割之组成部分，请您务必留意查看。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">九、联系我们</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">地址：海南省澄迈县老城镇海南生态软件园孵化楼4层1001</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">网站【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{officialWebsite}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">邮箱【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{email}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>
</div>`, 
        template_qzkxppc_oppo: `<div style='overflow-x: hidden;'>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">{{productName}}</span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">【特别提示】</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">一、定义</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span><span
        style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span><span
        style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span><span
style="font-family:宋体; font-size:10.5pt">{{productName}}</span><span
style="font-family:宋体; font-size:10.5pt">的应用。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.4 红包：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数等。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获红包按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得红包、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">二、本应用服务</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.1 【获取】您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.2 【功能】您在可在本应用内进行相应互动点击操作，满足一定条件时可获得红包奖励，并按规则进行红包兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的红包，应用内所展示红包数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.3 【更新】为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括红包兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.4 【广告】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，请您自行辨认本应用内广告的真实性。</span><span
style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免上当受骗。</span><span
</p>       


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.5 【中止、变更、中断】我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span><span
style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
</p>     

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">三、用户</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.1 【注册条件】您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.2 【使用目的】您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行红包兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.3【用户账号】我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.4【转让和共享禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内红包仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.5 【第三方工具禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取红包、频繁申请红包兑换或体现等可能影响本应用正常运行的行为。</span><span
style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.6 【账号注销】用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.7 【故障谅解】您理解互联网服务可能因技术或网络故障等原因导致红包兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.8【设备和网络】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span><span
style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.9 【限制传播】我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.10 【个人信息】保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">四、红包和兑换</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.1 【红包获取】我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的红包。但</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">成功获取红包数值不等同于最终可实际兑换价值，您必须要满足我们为您设置的兑换条件方可成功进行兑换，未成功兑换的红包不具有任何经济价值。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.2 【红包展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解红包所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。</span></p>           

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.3 【兑换资格】您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取红包等违规行为；已获取且在有效期内的红包数值大于等于您欲兑换数值。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.4 【数值展示】应用内红包处所显示数值并非实际可兑换数值，该数值系通过已获得红包数值减去已兑换和消耗红包数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.5 【兑换申请】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，</span><span
style="font-family:宋体; font-size:10.5pt">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换。</span>
</p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.6 【兑换审核】我们会在收到您的兑换申请后尽快为您处理，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换红包数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.7 【兑换发放】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意红包可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span><span
style="font-family:宋体; font-size:10.5pt">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
</p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.8 【兑换放弃】您理解并同意如您连续20日未登录本应用账号或自行注销本应用账号，则视为您已自愿放弃账号内全部已获得红包的兑换，并不再向我们提出兑换申请。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">五、具体兑换规则</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.1 【兑换规则】您确认知悉和理解本应用内的红包获取和兑换应当在符合前述“红包和兑换”条件的基础上，再按照以下具体兑换规则对照进行兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如本部分“兑换规则”所述兑换条件高于前述“红包和兑换”中所列条件的，则以下述“兑换规则”部分为准；如低于前述“红包和兑换”中所列条件的，则以前述“红包和兑换”部分为准。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.2 【规则展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并知悉应用内页面显示兑换规则相关内容系本协议的组成部分，但受移动设备和应用界面等因素影响，兑换页面所载“提现规则”或其他名称标注的兑换规则内容可能并不完整，我们有权根据情况决定规则的展示形式，您应仔细阅读本协议中包括但不限于本部分关于红包兑换的内容。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.3 【兑换比例】您理解并知悉红包与实际兑换价值的比例以应用内页面所载比例为准，计算方式为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">可兑换红包数值乘以页面所载兑换比例。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.4 【提现规则】</span></p>       


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.单笔提现金额最低0.3元。“全部提现”类型的提现项，单笔最大金额为1000元，每日最多10次提现，总体次数不限。“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，且每个任务或者档位只可提现一次；</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.每一项或者每一“档位”提现没有注册时长的限制。只要用户达到对应“档位”的金额要求即可完成提现，无其他要求，不同用户花费的时长也不一样。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">六、违约处理</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.1 【商业目的和不正当手段】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部红包、收回已兑换奖励。</span><span
style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
</p>   

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.2 【不得侵害本应用权利】任何人未经我们同意不得从事以下行为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span><span
style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">七、不可抗力和免责事由</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.1 【不可抗力】您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.2【技术故障免责】在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.3【外来风险免责】您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span><span
style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
</p>  

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.4【违规处理免责】我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.5【第三方消费免责】本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.6 【涉财产行为免责】在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.7 【非可控故障免责】我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">八、其他条款</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.1 【协议生效和争议解决】本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.2 【知识产权声明】在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.3 【协议修订】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择注销已注册的本应用账号。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.4 【协议性质】您确认本协议系您作为用户与我司平等订立的用户协议，红包及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.5 【协议范围】您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站上发布的公告、规则等内容为本协议不可分割之组成部分，请您务必留意查看。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">九、联系我们</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">地址：海南省澄迈县老城镇海南生态软件园孵化楼4层1001</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">网站【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{officialWebsite}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">邮箱【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{email}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>
</div>`, 

// 天天消砖块
template_qzttxzk: `<div style='overflow-x: hidden;'>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">{{productName}}</span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">【特别提示】</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">一、定义</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span><span
        style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span><span
        style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span><span
style="font-family:宋体; font-size:10.5pt">{{productName}}</span><span
style="font-family:宋体; font-size:10.5pt">的应用。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.4 红包：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数等。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获红包按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得红包、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">二、本应用服务</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.1 【获取】您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.2 【功能】您在可在本应用内进行相应互动点击操作，满足一定条件时可获得红包奖励，并按规则进行红包兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的红包，应用内所展示红包数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.3 【更新】为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括红包兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.4 【广告】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，请您自行辨认本应用内广告的真实性。</span><span
style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免上当受骗。</span><span
</p>       


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.5 【中止、变更、中断】我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span><span
style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
</p>     

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">三、用户</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.1 【注册条件】您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.2 【使用目的】您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行红包兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.3【用户账号】我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.4【转让和共享禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内红包仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.5 【第三方工具禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取红包、频繁申请红包兑换或体现等可能影响本应用正常运行的行为。</span><span
style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.6 【账号注销】用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.7 【故障谅解】您理解互联网服务可能因技术或网络故障等原因导致红包兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.8【设备和网络】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span><span
style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.9 【限制传播】我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.10 【个人信息】保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">四、红包和兑换</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.1 【红包获取】我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的红包。但</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">成功获取红包数值不等同于最终可实际兑换价值，您必须要满足我们为您设置的兑换条件方可成功进行兑换，未成功兑换的红包不具有任何经济价值。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.2 【红包展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解红包所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。</span></p>           

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.3 【兑换资格】您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取红包等违规行为；已获取且在有效期内的红包数值大于等于您欲兑换数值。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.4 【数值展示】应用内红包处所显示数值并非实际可兑换数值，该数值系通过已获得红包数值减去已兑换和消耗红包数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.5 【兑换申请】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，</span><span
style="font-family:宋体; font-size:10.5pt">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换。</span>
</p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.6 【兑换审核】我们会在收到您的兑换申请后尽快为您处理，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换红包数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.7 【兑换发放】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意红包可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span><span
style="font-family:宋体; font-size:10.5pt">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
</p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.8 【兑换放弃】您理解并同意如您连续20日未登录本应用账号或自行注销本应用账号，则视为您已自愿放弃账号内全部已获得红包的兑换，并不再向我们提出兑换申请。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">五、具体兑换规则</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.1 【兑换规则】您确认知悉和理解本应用内的红包获取和兑换应当在符合前述“红包和兑换”条件的基础上，再按照以下具体兑换规则对照进行兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如本部分“兑换规则”所述兑换条件高于前述“红包和兑换”中所列条件的，则以下述“兑换规则”部分为准；如低于前述“红包和兑换”中所列条件的，则以前述“红包和兑换”部分为准。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.2 【规则展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并知悉应用内页面显示兑换规则相关内容系本协议的组成部分，但受移动设备和应用界面等因素影响，兑换页面所载“提现规则”或其他名称标注的兑换规则内容可能并不完整，我们有权根据情况决定规则的展示形式，您应仔细阅读本协议中包括但不限于本部分关于红包兑换的内容。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.3 【兑换比例】您理解并知悉红包与实际兑换价值的比例以应用内页面所载比例为准，计算方式为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">可兑换红包数值乘以页面所载兑换比例。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.4 【提现规则】</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt"></span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.【我的现金】提现规则</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">A、0.3元提现：如您想在{{productName}}【红包提现】账户成功提现0.3元，则不需要条件。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">B、500元提现：如您想在{{productName}}【红包提现】账户成功提现500元，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于500元；2）消除至少1200次；3）登连续登录10天；4）累计观看350个视频；5）等级达到30级。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.【红包兑换】提现规则</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">a、 1.0%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的1.0%，则需要满足在{{productName}}消除0次。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">b、 1.2%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的1.2%，则需要满足在{{productName}}消除100次。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">c、 1.5%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的1.5%，则需要满足在{{productName}}消除300次。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">d、 6.0%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的6%，则需要满足在{{productName}}消除800次。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">e、 20.0%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的20.0%，则需要满足在{{productName}}消除1200次。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">f、 100.0%提现比例提现：如您想在{{productName}}【我的红包】账户成功提现红包金额的100.0%，则需要满足在{{productName}}消除1800次。</span></p>



<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">六、违约处理</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.1 【商业目的和不正当手段】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部红包、收回已兑换奖励。</span><span
style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
</p>   

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.2 【不得侵害本应用权利】任何人未经我们同意不得从事以下行为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span><span
style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">七、不可抗力和免责事由</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.1 【不可抗力】您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.2【技术故障免责】在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.3【外来风险免责】您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span><span
style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
</p>  

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.4【违规处理免责】我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.5【第三方消费免责】本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.6 【涉财产行为免责】在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.7 【非可控故障免责】我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">八、其他条款</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.1 【协议生效和争议解决】本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.2 【知识产权声明】在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.3 【协议修订】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择注销已注册的本应用账号。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.4 【协议性质】您确认本协议系您作为用户与我司平等订立的用户协议，红包及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.5 【协议范围】您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站上发布的公告、规则等内容为本协议不可分割之组成部分，请您务必留意查看。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">九、联系我们</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">地址：海南省澄迈县老城镇海南生态软件园孵化楼4层1001</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">网站【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{officialWebsite}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">邮箱【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{email}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>
</div>`, 

// {{productName}}
template_qzywhz: `<div style='overflow-x: hidden;'>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">{{productName}}</span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">【特别提示】</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">一、定义</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span><span
        style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span><span
        style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span><span
style="font-family:宋体; font-size:10.5pt">{{productName}}</span><span
style="font-family:宋体; font-size:10.5pt">的应用。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.4 红包：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数等。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获红包按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得红包、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">二、本应用服务</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.1 【获取】您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.2 【功能】您在可在本应用内进行相应互动点击操作，满足一定条件时可获得红包奖励，并按规则进行红包兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的红包，应用内所展示红包数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.3 【更新】为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括红包兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.4 【广告】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，请您自行辨认本应用内广告的真实性。</span><span
style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免上当受骗。</span><span
</p>       


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.5 【中止、变更、中断】我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span><span
style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
</p>     

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">三、用户</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.1 【注册条件】您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.2 【使用目的】您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行红包兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.3【用户账号】我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.4【转让和共享禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内红包仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.5 【第三方工具禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取红包、频繁申请红包兑换或体现等可能影响本应用正常运行的行为。</span><span
style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.6 【账号注销】用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.7 【故障谅解】您理解互联网服务可能因技术或网络故障等原因导致红包兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.8【设备和网络】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span><span
style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.9 【限制传播】我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.10 【个人信息】保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">四、红包和兑换</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.1 【红包获取】我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的红包。但</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">成功获取红包数值不等同于最终可实际兑换价值，您必须要满足我们为您设置的兑换条件方可成功进行兑换，未成功兑换的红包不具有任何经济价值。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.2 【红包展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解红包所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。</span></p>           

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.3 【兑换资格】您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取红包等违规行为；已获取且在有效期内的红包数值大于等于您欲兑换数值。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.4 【数值展示】应用内红包处所显示数值并非实际可兑换数值，该数值系通过已获得红包数值减去已兑换和消耗红包数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.5 【兑换申请】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，</span><span
style="font-family:宋体; font-size:10.5pt">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换。</span>
</p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.6 【兑换审核】我们会在收到您的兑换申请后尽快为您处理，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换红包数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.7 【兑换发放】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意红包可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span><span
style="font-family:宋体; font-size:10.5pt">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
</p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.8 【兑换放弃】您理解并同意如您连续20日未登录本应用账号或自行注销本应用账号，则视为您已自愿放弃账号内全部已获得红包的兑换，并不再向我们提出兑换申请。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">五、具体兑换规则</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.1 【兑换规则】您确认知悉和理解本应用内的红包获取和兑换应当在符合前述“红包和兑换”条件的基础上，再按照以下具体兑换规则对照进行兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如本部分“兑换规则”所述兑换条件高于前述“红包和兑换”中所列条件的，则以下述“兑换规则”部分为准；如低于前述“红包和兑换”中所列条件的，则以前述“红包和兑换”部分为准。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.2 【规则展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并知悉应用内页面显示兑换规则相关内容系本协议的组成部分，但受移动设备和应用界面等因素影响，兑换页面所载“提现规则”或其他名称标注的兑换规则内容可能并不完整，我们有权根据情况决定规则的展示形式，您应仔细阅读本协议中包括但不限于本部分关于红包兑换的内容。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.3 【兑换比例】您理解并知悉红包与实际兑换价值的比例以应用内页面所载比例为准，计算方式为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">可兑换红包数值乘以页面所载兑换比例。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.4 【提现规则】</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.【基金提现】提现规则</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">A、基金收益提现：如您想在{{productName}}【基金收益】账户成功提现，则需要同时满足以下几个条件即可成功提现： </span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1）账户红包余额不少于500元；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2）完成650关；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3）完成7个豪宅；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4）累计观看300个视频  </span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">B、豪宅基金提现：如您想在{{productName}}【基金提现】账户成功提现，则需要同时满足以下几个条件即可成功提现：</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1）账户红包余额不少于888元</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2）完成650关；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3）完成7个豪宅；</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4）累计观看300个视频  </span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt"></span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.【红包兑换】提现规则</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">a、 1.0%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.0%，则需要满足在{{productName}}完成0个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">b、 1.2%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.2%，则需要满足在{{productName}}完成2个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">c、 1.5%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.5%，则需要满足在{{productName}}完成4个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">d、 6.0%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的20.0%，则需要满足在{{productName}}完成9个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">e、 20.0%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的50.0%，则需要满足在{{productName}}完成15个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">f、 100.0%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的100.0%，则需要满足在{{productName}}完成36个房间。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">单笔提现最低0.3，最高2000元。</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">部分提现需要验证账号无风险，若有风险则须邀请好友验证辅助提现</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3、签到所领红包均为展示最高金额，实际到账会根据用户真实价值发放。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">六、违约处理</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.1 【商业目的和不正当手段】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部红包、收回已兑换奖励。</span><span
style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
</p>   

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.2 【不得侵害本应用权利】任何人未经我们同意不得从事以下行为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span><span
style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">七、不可抗力和免责事由</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.1 【不可抗力】您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.2【技术故障免责】在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.3【外来风险免责】您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span><span
style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
</p>  

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.4【违规处理免责】我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.5【第三方消费免责】本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.6 【涉财产行为免责】在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.7 【非可控故障免责】我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">八、其他条款</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.1 【协议生效和争议解决】本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.2 【知识产权声明】在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.3 【协议修订】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择注销已注册的本应用账号。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.4 【协议性质】您确认本协议系您作为用户与我司平等订立的用户协议，红包及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.5 【协议范围】您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站上发布的公告、规则等内容为本协议不可分割之组成部分，请您务必留意查看。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">九、联系我们</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">地址：海南省澄迈县老城镇海南生态软件园孵化楼4层1001</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">网站【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{officialWebsite}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">邮箱【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{email}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>
</div>`,  
template_qzywhz_oppo: `<div style='overflow-x: hidden;'>
<p style="margin:0pt; orphans:0; text-align:center; widows:0"><span
        style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">{{productName}}</span><span
        style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span></p>
<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
        style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">【特别提示】</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">一、定义</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
        style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span><span
        style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span><span
        style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span><span
style="font-family:宋体; font-size:10.5pt">{{productName}}</span><span
style="font-family:宋体; font-size:10.5pt">的应用。</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.4 红包：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数等。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获红包按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得红包、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">二、本应用服务</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.1 【获取】您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.2 【功能】您在可在本应用内进行相应互动点击操作，满足一定条件时可获得红包奖励，并按规则进行红包兑换。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的红包，应用内所展示红包数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.3 【更新】为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括红包兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.4 【广告】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，请您自行辨认本应用内广告的真实性。</span><span
style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免上当受骗。</span><span
</p>       


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">2.5 【中止、变更、中断】我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span><span
style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
</p>     

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">三、用户</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.1 【注册条件】您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.2 【使用目的】您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行红包兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.3【用户账号】我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.4【转让和共享禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内红包仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.5 【第三方工具禁止】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取红包、频繁申请红包兑换或体现等可能影响本应用正常运行的行为。</span><span
style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.6 【账号注销】用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.7 【故障谅解】您理解互联网服务可能因技术或网络故障等原因导致红包兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.8【设备和网络】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span><span
style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.9 【限制传播】我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">3.10 【个人信息】保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span></p>


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">四、红包和兑换</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.1 【红包获取】我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的红包。但</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">成功获取红包数值不等同于最终可实际兑换价值，您必须要满足我们为您设置的兑换条件方可成功进行兑换，未成功兑换的红包不具有任何经济价值。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.2 【红包展示】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解红包所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。</span></p>           

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.3 【兑换资格】您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取红包等违规行为；已获取且在有效期内的红包数值大于等于您欲兑换数值。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.4 【数值展示】应用内红包处所显示数值并非实际可兑换数值，该数值系通过已获得红包数值减去已兑换和消耗红包数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.5 【兑换申请】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，</span><span
style="font-family:宋体; font-size:10.5pt">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换。</span>
</p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.6 【兑换审核】我们会在收到您的兑换申请后尽快为您处理，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换红包数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.7 【兑换发放】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意红包可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span><span
style="font-family:宋体; font-size:10.5pt">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
</p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">4.8 【兑换放弃】您理解并同意如您连续20日未登录本应用账号或自行注销本应用账号，则视为您已自愿放弃账号内全部已获得红包的兑换，并不再向我们提出兑换申请。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">五、具体兑换规则</span></p>


<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.1 用户理解并同意：如果用户不接受“{{productName}}”红包玩法和规则，请用户不要使用“{{productName}}钱包”及提现等相关服务，这不影响用户继续享受“{{productName}}”软件的核心功能；用户的使用，将被视为同意“{{productName}}”红包玩法和规则并接受相应后果。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.2  用户理解并同意，“{{productName}}钱包”所记录的提现余额不同于用户本人的存款，其实质为“{{productName}}”发放的可提现金余额，在用户提现前所有权属于{{companyFullName}}。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.3 用户理解并同意，平台上所有标注的提现金额系用户达到每日完成数量、登录一定天数、一定等级情况下所能够获得的最大提现金额，我们为了用户良好的产品体验和出于页面展示的考虑会在用户满足每日完成数量、连续登录天数后再展示相应等级级别。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.4 【提现规则】</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">{{productName}} “软件有权自主制定、变更红包及现金的发放数量及提现规则。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（1）.由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（2）.单笔提现金额最低0.3元。每日最多10次提现，总体次数不限。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（3）.“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，且每个任务或者档位只可提现一次；</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（4）.每一项只要用户达到对应“档位”的金额要求即可完成提现，无其他要求，不同用户花费的时长也不一样。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（5）.部分提现需要验证账号无风险，若有风险则须邀请好友验证辅助提现</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（6）.除下述提及的档位提现要求以外，无注册时长条件，无在线时长条件，无提现间隔条件。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（7）.部分账号涉及到邀请好友。每邀请一个新用户可得0.5元，之后被邀请用户每次看视频可获得0.05元，每天上限10次。被邀请用户成功提现一次即可成为有效好友。
邀请好友提现满0.3元即可提现，每天上限提现10次，无其他提现要求。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（8）.【基金提现】提现规则</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">A、基金收益提现：如您想在{{productName}}【基金收益】账户成功提现，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于500元；2）完成650关；  3）完成7个豪宅；4）累计观看300个视频  </span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">B、豪宅基金提现：如您想在{{productName}}【基金提现】账户成功提现，则需要同时满足以下几个条件即可成功提现：1）账户红包余额不少于888元；2）完成650关；  3）完成7个豪宅；4）累计观看300个视频  </span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">（9）.【红包兑换】提现规则</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">a、 1.0%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.0%，则需要满足在{{productName}}完成0个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">b、 1.2%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.2%，则需要满足在{{productName}}完成2个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">c、 1.5%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的1.5%，则需要满足在{{productName}}完成4个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">d、 20%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的20.0%，则需要满足在{{productName}}完成9个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">e、 50%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的50.0%，则需要满足在{{productName}}完成15个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">f、 120%提现比例提现：如您想在{{productName}}【红包兑换】账户成功提现红包金额的120%，则需要满足在{{productName}}完成36个房间。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.5  用户理解并同意，产品内的“余额（包括但不限于金币、红包、积分、元宝等）”是产品内 “虚拟积分”，在用户提现前所有权属于{{companyFullName}}，若用户连续30天（包含30天）不使用“{{productName}}”软件进行活动，公司有权单方将用户“ {{productName}}钱包”余额（包括但不限于金币、红包、积分、元宝等）清零。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.6  用户理解并同意“{{productName}}”的规则、玩法等由公司制作、发布，公司有权视产品运营情况对规则、玩法等进行更新和调整并进行公示，该公示视为将更新和调整后的规则、玩法等送达用户。用户应及时查看，以便了解和更好地体验“{{productName}}”。 平台有权单方制定、调整、变更阅读任意平台内容、红色标志平台内容等活动或任务的奖励规则，并享有对玩法和规则的解释权。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.7  用户理解并同意如果用户的余额获得是通过系统bug等非正常渠道获得，“{{productName}}”有权拒绝兑换、相关现金的提现等行为，并将会对账户进行处理，严重时有权封停账户。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.8  用户理解并同意，提现服务（包含但不限于常规提现、抽奖提现等全部提现行为）由公司委托给第三方平台公司提供，因第三方打款平台限制，每日最多提现30次、次日登录恢复，用户单日累计提现数额较大，会触发风控审核。部分用户操作提现时可能会出现提现延迟、触发风控和账户异常等问题，部分用户在提现时会有以下提示：</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">a提现失败。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">b非实名账号无法发放。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">c 账户异常，限制收款。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">d 存在风险，微信已拦截。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">如遇到“提现失败”提示，用户可以发起客服咨询，提供ID-“{{productName}}号”和“产品提现页面截图”进行反馈，在线客服会实时解决用户的问题；如遇到无法实时解决的问题，客服会和要求用户提供联系方式，并将用户的ID-“{{productName}}号”、联系方式一同反馈至公司，相关部门在3个工作日之内将研判结果反馈给用户。 如果用户未与我们的产品客服沟通而直接寻求第三方帮助的，请谅解我们将无法第一时间为用户解决问题。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.9  平台中显示的用户的累计账号金额与公司的服务器端存在统计差异，实际账号金额以服务器端统计为准。若因平台系统自身故障或其他原因造成系统显示用户获得的金币、零钱或收入数量（系统显示数量）与根据平台规则用户应得的金币、金额（实际应得数量）不符，若系统显示数量少于实际应得数量，平台予以补其差额或调整；若系统显示数量大于实际应得数量，平台有权追回差额或调整。如用户认为账号收入出现错误，须在90天内向公司提出更正要求，公司如果判定用户的要求正当合理，将在90天内进行更正。</span></p> 
<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">5.10  在此声明，在使用“现金红包”过程中可能产生的非“{{productName}}”原因的一切风险，均由用户自行承担。在法律允许的最大范围内，任何情况下，{{companyFullName}}不就因使用或不能使用“现金红包”所发生的特殊的、意外的、非直接或间接的损失承担赔偿责任。即使用户已被事先告知该损失发生的可能性。</span></p> 


<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">六、违约处理</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.1 【商业目的和不正当手段】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部红包、收回已兑换奖励。</span><span
style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
</p>   

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">6.2 【不得侵害本应用权利】任何人未经我们同意不得从事以下行为：</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span><span
style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
</p>   

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">七、不可抗力和免责事由</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.1 【不可抗力】您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.2【技术故障免责】在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.3【外来风险免责】您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span><span
style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
</p>  

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.4【违规处理免责】我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.5【第三方消费免责】本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.6 【涉财产行为免责】在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span></p>       

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">7.7 【非可控故障免责】我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">八、其他条款</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.1 【协议生效和争议解决】本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.2 【知识产权声明】在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span></p>

<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.3 【协议修订】</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择注销已注册的本应用账号。</span></p>       

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.4 【协议性质】您确认本协议系您作为用户与我司平等订立的用户协议，红包及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">8.5 【协议范围】您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站上发布的公告、规则等内容为本协议不可分割之组成部分，请您务必留意查看。</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; widows:0"><span
style="font-family:Calibri; font-size:10.5pt">&#xa0;</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">九、联系我们</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">地址：海南省澄迈县老城镇海南生态软件园孵化楼4层1001</span></p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">网站【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{officialWebsite}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>

<p style="margin:0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0"><span
style="font-family:宋体; font-size:10.5pt">邮箱【</span><span
style="font-family:宋体; font-size:10.5pt; font-weight:bold">{{email}}</span><span
style="font-family:宋体; font-size:10.5pt">】</span>
</p>
</div>`,  
}

